export default () => {
  const FADE_TOGGLE = 150;
  const filterDiv = $('#js-materials-filter');

  if(filterDiv.length > 0) {
    const $document = $('document');
    const $page = $('html, body');
    const $body = $('body');
    const headerHeight = $('#js-header').outerHeight();
    const materialFilterHeight = filterDiv.outerHeight();
    const materialTab = $('.js-materials-tab');
    const $filterIcon = $('.js-filter-icon');
    const $mobileCategory = $('#js-filter-mobile-category');
    const $mobileFilter = $('#js-filter-mobile-filter');
    const $mobileToggle = $('.js-mobile-toggle');
    const $mobileOverlay = $('#js-filter-mobile-overlay');
    const $mobileBackdrop = $('.hamburger-menu-backdrop');

    function offsetBottom(el, i) { i = i || 0; return $(el)[i].getBoundingClientRect().bottom }

    function getActiveTab() {
      const TAB_OFFSET = 200;
      let scrollTop = $(window).scrollTop();
      let i;

      for(i = 1; i <= 3; i++) {
        let $tab = $('#js-material-tab-' + i);
        let tabTop;
        let tabBottom;

        if($tab.length > 0) {
          tabTop = $tab.offset().top - materialFilterHeight;
          tabTop = tabTop - TAB_OFFSET;
          tabBottom = offsetBottom('#js-material-tab-' + i);
          tabBottom = tabBottom - TAB_OFFSET;
        }

        let slug = $('.js-materials-tab[data-tab="' + i + '"]').data('name');
        let name = $('.js-materials-tab[data-tab="' + i + '"]').html();

        if(scrollTop > tabTop && tabBottom > 0) {
          // remove any active classes
          $('.c-tabs__item.is-active').removeClass('is-active');

          // add it to the new clicked element
          $('.js-materials-tab[data-tab="' + i + '"]').closest('.c-tabs__item').addClass('is-active');

          // change the active category text on mobile
          if($mobileCategory.text() !== name) {
            $mobileCategory.text(name);
          }

          // add the hash to the URL
          // window.location.hash = slug;
        }
      }
    }

    $document.ready(() => {
      if(window.location.hash) {
        let hash = window.location.hash.substring(1);

        $('.js-materials-tab[data-name="' + hash + '"]').trigger('click', [true]);
      }
    });

    $(window).scroll(() => {
      getActiveTab();
    });

    function toggleMobileOverlay() {
      $mobileOverlay.addClass('is-toggling');

      $mobileOverlay.stop().slideToggle(300, () => {
        $mobileOverlay.removeClass('is-toggling');
        if($mobileOverlay.is(":visible") == true){
            $body.addClass('has-mobile-filters-open');
        }
        else {
            $body.removeClass('has-mobile-filters-open');
        }
      });
      
    }
    
    $('#js-wrapper, #js-header').on('scroll touchmove mousewheel', function(e) {
        if($body.hasClass('has-mobile-filters-open')) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });

    let sticky = new Waypoint.Sticky({
      element: filterDiv[0],
      stuckClass: 'is-fixed',
      offset: function() {
        let filterOffset;

        if($body.hasClass('has-fixed-header')) {
          filterOffset = headerHeight;
        } else {
          filterOffset = 0;
        }

        return filterOffset;
      }
    });

    function goToElement(element) {
      let offset = materialFilterHeight;

      if($body.hasClass('has-fixed-header')) {
        offset += headerHeight;
      }

      $page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', () => {
        $page.stop();
      });

      $page.animate({ scrollTop: element.offset().top - offset }, 'slow', () => {
        $page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
      });
    }

    $mobileToggle.on('click', function(e) {
      let toggle = $(this).data('toggle');
      const $mobileIcons = $('#js-materials-filter-mobile-icons');
      const $mobileTabs = $('#js-materials-filter-mobile-tabs');

      if(toggle === 'category') {
        $mobileTabs.show();
        $mobileIcons.hide();
        $mobileFilter.fadeToggle(FADE_TOGGLE);
      } else if(toggle === 'filter') {
        $mobileIcons.show();
        $mobileTabs.hide();
        $mobileCategory.fadeToggle(FADE_TOGGLE);
      } else if(toggle === 'close') {
        $mobileCategory.fadeIn(FADE_TOGGLE);
        $mobileFilter.fadeIn(FADE_TOGGLE);
      }

      if($mobileOverlay.hasClass('is-toggling')) {
        return;
      }

      toggleMobileOverlay();

      e.preventDefault();
    });
    
    $mobileBackdrop.on('click', function(e){
        if($mobileOverlay.length && $body.hasClass('has-mobile-filters-open')){
            toggleMobileOverlay();
            $mobileCategory.fadeIn(FADE_TOGGLE);
            $mobileFilter.fadeIn(FADE_TOGGLE);
        }
    });

    $('#js-filter-mobile-overlay .c-tabs__link').on('click', function(e, noToggle) {
      if(!noToggle) {
        toggleMobileOverlay();
      }
    });

    materialTab.on('click', function(e, noToggle) {
      let $this = $(this);
      let tab = $this.data('tab');
      let slug = $this.data('name');
      let element = $('.js-material-section[data-tab="' + tab + '"]');

      // add the hash to the URL
      // window.location.hash = slug;

      // scroll to that element
      goToElement(element);

      // make sure we fade in the mobile category and filter
      $mobileCategory.fadeIn(FADE_TOGGLE);
      $mobileFilter.fadeIn(FADE_TOGGLE);

      e.preventDefault();
    });

    let $grid = $('.c-material-thumbs').isotope({
      itemSelector: '.c-material-thumb',
      layoutMode: 'masonry',
      hiddenStyle: {
        opacity: 0
      },
      visibleStyle: {
        opacity: 1
      }
    });

    let filter = [];
    let filterValue = null;

    $('.c-materials-filter__item').on({
      mouseleave: function () {
        if($(this).hasClass('is-hovered')) {
          $(this).removeClass('is-hovered');
        }
      }
    });

    $filterIcon.on('click', function(e) {
      e.preventDefault();

      let thisFilter = '.cat-' + $(this).data('filter');
      let $this = $('.js-filter-icon[data-filter="' + $(this).data('filter') + '"]');

      // remove any other active tabs
      if(!$this.closest('li').hasClass('is-active')) {
        filter.push(thisFilter);
        $this.closest('li').removeClass('is-active').addClass('is-hovered');
      } else {
        var index = filter.indexOf(thisFilter);
        $this.closest('li').addClass('is-hovered');
        filter.splice(index, 1);
      }

      if(filter.length > 0) {
        filterValue = filter.join();
      } else {
        filterValue = '*';
      }

      $this.closest('li').toggleClass('is-active');
      $grid.isotope({ filter: filterValue });
    });

    $grid.on('layoutComplete', function() {
      let activeTab = $('.c-tabs__item.is-active a').data('tab');
      let activeSection = $('.js-material-section[data-tab="' + activeTab + '"]');

      // go to active section
      // goToElement(activeSection);

      // refresh waypoints
      Waypoint.refreshAll();
    });
  }
};
